const heroConfig = {
	color: {
		sg: "1",
		gn: "1",
		gp: "1",
	},
};

export default heroConfig;
